export default __webpack_public_path__ + "static/media/icon_YellowMetal.18685708.png";